import { dialogsListApi } from '@shared/api/dialogs-list-api';
import { generatedApi } from '@shared/api/generated-api';
import type { RootState } from '@shared/redux';

export const dialogsEndpoints = {
  getDialogHistoryDialogHistoryGet: {},
  getLastManagerMessageDialogGetLastManagerMessagePost: {
    invalidatesTags: [],
  },

  sendDialogMessageDialogSendPost: {
    invalidatesTags: [],
    async onQueryStarted(queryArgs, { dispatch, queryFulfilled, getState }) {
      try {
        const { data } = await queryFulfilled;
        if (!data?.id) return;

        const clientId = queryArgs.bodySendDialogMessageDialogSendPost.client_id;

        const getListDialogsArgs = dialogsListApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'getListDialogsDialogListPostQuery',
        );

        const getDialogHistoryArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'getDialogHistoryDialogHistoryGet',
        );

        for (const args of getListDialogsArgs) {
          dispatch(
            dialogsListApi.util.updateQueryData(
              'getListDialogsDialogListPostQuery',
              args,
              (draft) => {
                if (!draft.items) return;

                const currentIndex = draft.items.findIndex((item) => item.client_id === clientId);
                const currentDialog = currentIndex >= 0 ? draft.items[currentIndex] : null;

                const updatedDialog = currentDialog
                  ? {
                      ...currentDialog,
                      last_message_at: data.created_at,
                      last_message: queryArgs.bodySendDialogMessageDialogSendPost.message,
                    }
                  : null;

                if (!updatedDialog) return;

                const restDialogs = draft.items.filter((_, index) => index !== currentIndex);
                draft.items = [updatedDialog, ...restDialogs].sort((a, b) => {
                  const aTime = a.last_message_at ?? '';
                  const bTime = b.last_message_at ?? '';
                  return bTime.localeCompare(aTime);
                });
              },
            ),
          );
        }

        for (const args of getDialogHistoryArgs) {
          if (args.clientId !== clientId) continue;

          dispatch(
            generatedApi.util.updateQueryData('getDialogHistoryDialogHistoryGet', args, (draft) => {
              const items = draft.items ?? [];
              const exists = items.some((item) => item.id === data.id);
              if (exists) return;

              items.push({
                id: data.id,
                creator_type: data.creator_type,
                message: data.message,
                created_at: data.created_at,
                manager_delta: data.manager_delta,
                is_form_shown: data.is_form_shown ?? false,
              });

              draft.items = items.sort((a, b) =>
                (a.created_at ?? '').localeCompare(b.created_at ?? ''),
              );

              if (typeof draft.count === 'number') {
                draft.count += 1;
              }
            }),
          );
        }
      } catch (error) {}
    },
  },

  addManagerDeltaTimeDialogAddManagerDeltaTimePost: {
    invalidatesTags: [],
    async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
      try {
        const { data } = await queryFulfilled;
        if (!data?.id) return;

        const updatedMessageId = data.id;

        const getDialogHistoryArgs = generatedApi.util.selectCachedArgsForQuery(
          getState() as RootState,
          'getDialogHistoryDialogHistoryGet',
        );

        for (const args of getDialogHistoryArgs) {
          dispatch(
            generatedApi.util.updateQueryData('getDialogHistoryDialogHistoryGet', args, (draft) => {
              const items = draft.items ?? [];
              const msg = items.find((m) => m.id === updatedMessageId);
              if (!msg) return;

              msg.manager_delta = data.manager_delta;
              msg.created_at = data.created_at;
            }),
          );
        }
      } catch {}
    },
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
